import { render, staticRenderFns } from "./editMainBanner.vue?vue&type=template&id=019228b6&"
import script from "./editMainBanner.vue?vue&type=script&lang=js&"
export * from "./editMainBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports